var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "temp-redirect" }, [
      _c("h3", [_vm._v("页面已迁移")]),
      _vm._v(" "),
      _c("p", [_vm._v("店铺管理功能已迁移到新位置，正在跳转...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }